const numberFormatter = new Intl.NumberFormat('fa-IR');

const digitMap = {
  '۰': '0',
  '۱': '1',
  '۲': '2',
  '۳': '3',
  '۴': '4',
  '۵': '5',
  '۶': '6',
  '۷': '7',
  '۸': '8',
  '۹': '9',
  '٠': '0',
  '١': '1',
  '٢': '2',
  '٣': '3',
  '٤': '4',
  '٥': '5',
  '٦': '6',
  '٧': '7',
  '٨': '8',
  '٩': '9',
};

export const formatNumber = (value) =>
  numberFormatter.format(Number.isFinite(Number(value)) ? Number(value) : 0);

export const formatToman = (amountIrr) =>
  `${formatNumber(Math.round(Number(amountIrr || 0) / 10))} تومان`;

export const formatTomanValue = (amountToman) =>
  `${formatNumber(amountToman)} تومان`;

export const parseLocalizedInteger = (value) => {
  const normalized = String(value ?? '')
    .replace(/[۰-۹٠-٩]/g, (digit) => digitMap[digit])
    .replace(/[^0-9]/g, '');
  return normalized ? Number(normalized) : 0;
};

export const makeIdempotencyKey = (tenantId, subject, variant) => {
  const nonce =
    globalThis.crypto?.randomUUID?.() || `${Date.now()}-${Math.random()}`;
  return `billing-${tenantId}-${subject}-${variant}-${nonce}`;
};

export const formatLimit = (value, unit) =>
  value == null ? 'بدون محدودیت' : `${formatNumber(value)} ${unit}`;
